import api from './api';

/**
 * 客户分组服务
 * 提供与客户分组相关的API
 */
const groupService = {
  /**
   * 获取所有客户分组 (旧方法名，保持向后兼容)
   * @param {Object} params - 可选的查询参数，如页码、每页大小等
   */
  getAllGroups: async (params = {}) => {
    try {
      // 传递分页和查询参数给后端
      const response = await api.get('/groups', { params });
      console.log('分组API返回数据:', response.data);
      
      // 处理后端可能返回的分页格式数据
      const data = response.data;
      if (data && data.content && Array.isArray(data.content)) {
        // 如果返回的是分页格式，提取 content 数组
        console.log('检测到分页格式，返回 content 数组');
        return data.content;
      }
      // 如果返回的直接是数组或其他格式，原样返回
      console.log('非分页格式，直接返回数据');
      return data;
    } catch (error) {
      console.error('获取客户分组列表失败:', error);
      throw error;
    }
  },

  /**
   * 获取群组列表 (新方法名，用于群发功能)
   * @param {Object} params - 可选的查询参数，如页码、每页大小等
   */
  getGroups: async (params = {}) => {
    try {
      // 设置较大的页面大小来获取所有群组用于群发选择
      const defaultParams = {
        page: 0,
        size: 1000,
        ...params
      };
      
      // 追加后端新支持的筛选参数
      const { ownerId, startTime, endTime, ...rest } = defaultParams;
      const queryParams = {
        ...rest,
        ...(ownerId ? { ownerId } : {}),
        ...(startTime ? { startTime } : {}),
        ...(endTime ? { endTime } : {})
      };
      
      const response = await api.get('/groups', { params: queryParams });
      console.log('群组API返回数据:', response.data);
      
      // 返回完整的分页数据，让调用方决定如何处理
      return response.data;
    } catch (error) {
      console.error('获取群组列表失败:', error);
      throw error;
    }
  },
  
  /**
   * 获取分组详情
   */
  getGroupById: async (groupId) => {
    try {
      const response = await api.get(`/groups/${groupId}`);
      return response.data;
    } catch (error) {
      console.error(`获取分组详情失败 ID:${groupId}:`, error);
      throw error;
    }
  },

  /**
   * 获取群组成员列表（包括已知客户和未知成员）
   */
  getGroupMembersWithUnknown: async (groupId) => {
    try {
      const response = await api.get(`/groups/${groupId}/members-with-unknown`);
      console.log('获取群组混合成员列表响应:', response.data);
      return response.data;
    } catch (error) {
      console.error(`获取群组混合成员列表失败 ID:${groupId}:`, error);
      throw error;
    }
  }
};

export default groupService; 